import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import iconKhachHang from "Resources/ImagesNew/iconKhachHang.png";
import iconKho from "Resources/ImagesNew/iconKho.png";
import cart from "Resources/ImagesNew/icon_cart.png";
import iconNhapHang from "Resources/ImagesNew/iconNhapHang.png";
import iconKeToan from "Resources/ImagesNew/iconKeToan.png";
import iconTraHang from "Resources/ImagesNew/iconTraHang.png";
import iconHeThong from "Resources/ImagesNew/iconHeThong.png";
import iconNhatKy from "Resources/ImagesNew/iconBaoCao.png";
import iconDuyetYeuCau from "Resources/ImagesNew/iconDuyetYeuCau.png";
import iconNhomKinh from "Resources/ImagesNew/iconNhomKinh.png";
import iconGiaCong from "Resources/ImagesNew/iconGiaCong.png";
import iconSanXuat from "Resources/ImagesNew/iconSanXuat.png";
import iconGiaoNhan from "Resources/ImagesNew/iconGiaoNhan.png";
import { getUrl, getPhienBan } from "utils/utils";

export const SidebarDataChucNang = [
  // {
  //   title: "Duyệt yêu cầu",
  //   path: getUrl() + "/Systems/DuyetYeuCau",
  //   icon: iconDuyetYeuCau,
  //   isShow: false,
  //   Code: "DuyetYeuCau",
  // },
  {
    title: "Khách hàng",
    path: getUrl() + "/Customers/Default.aspx",
    icon: iconKhachHang,
    isShow: true,
    Code: "",
  },
  {
    title: "Quản lý kho",
    path: getUrl() + "/Stores/Default.aspx",
    icon: iconKho,
    isShow: true,
    Code: "",
  },
  {
    title: "Lệnh gia công",
    path: getUrl() + "/LenhGiaCong/Default.aspx",
    icon: iconGiaCong,
    isShow: false,
    Code: "LenhGiaCong",
  },
  {
    title: "Lệnh sản xuất",
    path: getUrl() + "/LenhSanXuat/Default.aspx",
    icon: iconSanXuat,
    isShow: false,
    Code: "LenhSanXuat",
  },
  {
    title: "Giao nhận",
    path: getUrl() + "/GiaoNhan/Default.aspx",
    icon: iconGiaoNhan,
    isShow: false,
    Code: "GiaoNhan",
  },
  {
    title: "Bán hàng",
    path: getUrl() + "/Sale/Default.aspx",
    icon: cart,
    isShow: true,
    Code: "",
  },
  {
    title: "Trả hàng",
    path: getUrl() + "/TraHang/Default.aspx",
    icon: iconTraHang,
    isShow: true,
    Code: "",
  },
  {
    title: "Nhập hàng",
    path: getUrl() + "/Buy/Default.aspx",
    icon: iconNhapHang,
    isShow: true,
    Code: "NhapHang",
  },
  {
    title: "Kế toán",
    path: getUrl() + "/Accountant/Default.aspx",
    icon: iconKeToan,
    isShow: true,
    Code: "",
  },
  {
    title: "Hệ thống",
    path:
      getPhienBan() === "Multi"
        ? getUrl() + "/Systems/Default.aspx"
        : getUrl() + "/System/Default.aspx",
    icon: iconHeThong,
    isShow: true,
    Code: "",
  },
  {
    title: "Nhôm kính",
    path: getUrl() + "/DanhSachCongTrinh",
    icon: iconNhomKinh,
    isShow: false,
    Code: "NhomKinh",
  },
  {
    title: "Nhật ký",
    path: getUrl() + "/Sale/Diary.aspx",
    icon: iconNhatKy,
    isShow: true,
    Code: "",
  },
];
